
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; // Import auth
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the initialized Firebase app
export default app;

// Optionally, export Firestore if you're using it
export const db = getFirestore(app);
export const auth = getAuth(app); // Corrected Firebase auth initialization
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to emulators when in development on localhost
if (process.env.NODE_ENV === "development" && window.location.hostname === "localhost") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5002);
  // Use Firestore emulator only when explicitly enabled (run emulator + set REACT_APP_USE_EMULATORS=true)
  if (process.env.REACT_APP_USE_EMULATORS === "true") {
    connectFirestoreEmulator(db, "127.0.0.1", 8081);
  }
}

// Export the Google Auth provider
export const googleProvider = new GoogleAuthProvider();


